import { Component, HostListener, inject, isDevMode } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { ActivatedRoute, Router } from '@angular/router';
import { Logger } from './services/logger/logger.service';
import { formNestedValidate } from './helpers/form';

/**
 * @deprecated Используйте BaseFormComponent
 */
@Component({
  template: ``,
})
export abstract class BaseFormLegacyComponent {
  /**
   * Форма
   */
  form: FormGroup = new FormGroup({});
  /**
   * Обработка сервиса
   */
  isServiceInProgress = false;
  /**
   * Инициализация данных
   */
  isInit = true;
  /**
   * Ошибка
   */
  error = '';
  /**
   * Данные для дебага
   */
  protected debugValue?: object;

  protected fb = inject(FormBuilder);
  protected message = inject(NzMessageService);
  protected activateRoute = inject(ActivatedRoute);
  protected router = inject(Router);
  protected logger = inject(Logger);

  /**
   * @param ev
   */
  @HostListener('document:keydown', ['$event'])
  onKeyUp(ev: KeyboardEvent) {
    if (isDevMode()) {
      //  Ctrl + ShiftKey + V
      if (ev.ctrlKey && ev.shiftKey && ev.key === 'V') {
        console.log('Form value is', this.form?.getRawValue());
      }

      //  Ctrl + ShiftKey + F
      if (ev.ctrlKey && ev.shiftKey && ev.key === 'F') {
        console.log('Form is', this.form);
      }

      //  Ctrl + ShiftKey + L
      if (ev.ctrlKey && ev.shiftKey && ev.key === 'L') {
        if (this.debugValue) {
          this.form?.patchValue(this.debugValue);
        }
      }
    }
  }

  /**
   * Валидация формы
   */
  protected validate(form: FormGroup | FormControl = this.form) {
    formNestedValidate(form);
    return form.valid;
  }

  /**
   * Есть несохраненные данные
   */
  hasUnsavedData() {
    if (this.form) {
      return this.form.dirty && this.form.touched;
    } else {
      return false;
    }
  }
}
